module.exports = __webpack_public_path__ + "Roboto-Bold-webfont.8b18d65d6824460ad376.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Bold-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold-webfont.woff
// module chunks = styles